/**
 * shape-event-handlers.js
 * Event registration for shape instances
 */

import { UpdateShapeCommand } from '@/stores/shapeCommands'

/**
 * Register standard event handlers for a shape instance
 * @param {MapShape} shape - Shape instance (Area or Distance)
 * @param {Object} mainStore - Pinia main store instance
 * @param {Function} setCursor - Cursor update function
 * @param {Ref} initedShapes - Ref to array of all shape instances
 */
export function registerShapeEvents(shape, mainStore, setCursor, initedShapes) {
  // NEW: Sync shape changes to store via command queue (no more refreshShape)
  // This prevents circular dependencies and recursion
  shape.dispatcher.on('updated', () => {
    mainStore.commandQueue.enqueue(new UpdateShapeCommand(shape))
  })

  // Update cursor when handle selected
  shape.dispatcher.on('handleselected', () => {
    setCursor()
  })

  // Restore cursor when handle deselected
  shape.dispatcher.on('handledeselected', () => {
    setCursor()
  })

  // Update cursor and refresh other shapes' handles when mode changes
  shape.dispatcher.on('modechanged', () => {
    setCursor()
    // Update handles on all other shapes
    initedShapes.value
      .filter(s => s.indexID !== shape.indexID)
      .forEach(s => s.updateHandles())
  })
}
